import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("BnplApplicationStore");

const urls = {
  application: `/bnpl/in_store/application`,
};

const initState = () => {
  return {
    application: {
      items: [{}],
    },
    financierId: "",
    publicId: "",
  };
};

const actions = {
  create: async ({ state, commit }) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.post(urls.application, state.application);
      commit("setPublicId", data.publicId);
    } catch (err) {
      logger.error(err);
      console.log(err);
      await Promise.reject(err);
    }
  },
  clear: ({ commit }) => {
    commit("clearApplication");
  },
};

const mutations = {
  clearApplication: (state) => {
    Vue.set(state, "application", { items: [{}] });
    Vue.set(state, "financierId", "");
    Vue.set(state, "publicId", "");
  },
  addProduct: (state) => {
    state.application.items.push({});
  },
  removeProduct: (state, index) => {
    state.application.items.splice(index, 1);
  },
  updateProduct: (state, { index, key, value }) => {
    Vue.set(state.application.items[index], key, value);
  },
  saveApplication: async (state, data) => {
    Vue.set(state, "application", {
      ...data,
      totalAmount: state.application.items.reduce(
        (accumulator, currentValue) => {
          return accumulator + currentValue.quantity * currentValue.price;
        },
        0
      ),
      items: state.application.items,
    });
  },
  setFinancierId: (state, data) => {
    Vue.set(state, "financierId", data);
  },
  setPublicId: (state, data) => {
    Vue.set(state, "publicId", data);
  },
};

const getters = {
  getProducts: (state) => {
    return state.application.items;
  },
  getProduct: (state) => (index) => {
    return state.application.items[index];
  },
  getApplication: (state) => {
    return state.application;
  },
  getApplicationValue: (state) => {
    return state.application.items.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.quantity * currentValue.price;
    }, 0);
  },
  getUrlParams: (state) => {
    if (state.publicId && state.financierId) {
      return {
        publicId: state.publicId,
        financierId: state.financierId,
      };
    }
    return null;
  },
  getEmail: (state) => {
    return state.application.customerEmail;
  },
  getPhone: (state) => {
    return state.application.customerPhone;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
